export const Modal = {
  parts: ['dialog', 'body'],
  baseStyle: {
    dialog: {
      bg: 'brand.front',
      borderRadius: '3px',
      boxShadow: '2xl'
    },
    body: {
      pt: 2,
      pb: 4
    }
  }
}
